import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'Is this a physical product or a digital download?',
  a: 'This is a 100% digital product delivered in high-quality PDF format. You can instantly access it from your computer, tablet, or smartphone immediately after purchase.'
}, {
  q: 'Is it suitable for new gymnastics coaches?',
  a: 'Absolutely. The system is designed for both new coaches who want a complete coaching structure and experienced coaches looking to save time, stay organized, and deliver more professional practices.'
}, {
  q: 'Can I use it with recreational and competitive athletes?',
  a: 'Yes. The system is designed for coaches working with recreational, developmental, and competitive gymnasts of different ages and skill levels.'
}, {
  q: 'Can I adapt the practice plans to my own coaching style?',
  a: 'Absolutely. Every lesson plan, progression, and coaching resource can easily be adapted to your athletes, equipment, training schedule, and coaching philosophy.'
}, {
  q: 'How quickly will I notice the benefits?',
  a: 'Most gymnastics coaches report saving hours of planning time and feeling significantly more organized and confident from the very first practice using the system.'
}, {
  q: 'Do I need a lot of equipment or a large gym to use it?',
  a: 'No. The station layouts, drills, and progressions are designed to be flexible so you can adapt them to the apparatus, space, and equipment you already have — from full competitive gyms to small recreational programs.'
}, {
  q: 'Is this a one-time payment or a subscription?',
  a: 'It is a one-time payment. You pay $27 once and get lifetime access to the complete Gymnastics Coach Pro™ system and all 5 premium bonuses. There are no hidden fees or recurring charges.'
}, {
  q: 'Do I get access to the bonuses immediately?',
  a: 'Yes. All 5 premium bonuses are included with your purchase today and are delivered instantly by email alongside the complete 6-in-1 system.'
}, {
  q: 'What is the refund process if I am not satisfied?',
  a: 'Simply contact us within 7 days of your purchase and we will refund 100% of your money — no risk and no questions asked. Your investment is completely protected.'
}, {
  q: 'Do I need any special software to use the resources?',
  a: 'No special software is required. All resources open in standard PDF format using tools you already have, so you can start using them with your athletes right away.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-8 px-4 bg-white" data-id="element-38" data-mp="2yp66idcmi2kt">
      <div className="max-w-3xl mx-auto" data-id="element-39" data-mp="2ukomcd2cpn9i">
        <div className="text-center mb-6" data-id="element-40" data-mp="2unswrs6etf8m">
          <h2 className="text-2xl sm:text-3xl font-display font-extrabold text-brand-ink uppercase" data-id="element-41" data-mp="1n8ervbu82x31">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-2" data-id="element-42" data-mp="3utwpug3ws9a3">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-cloud border border-brand-line rounded-xl overflow-hidden" data-id="element-43" data-mp="3uvr9zs7cvxd4" data-mpi={i}>
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-4 py-3 text-left flex justify-between items-center hover:bg-brand-blue/5 transition-colors gap-3" aria-expanded={openIndex === i} data-id="element-44" data-mp="7ooz6qy6gccl">
                <span className="font-bold text-brand-ink text-sm sm:text-base leading-snug" data-id="element-45" data-mp="mduyeex0m2kh">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-blue transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-46" data-mp="qg810uggtkd1" />
              </button>

              {openIndex === i && <div className="px-4 pb-3 pt-0 text-brand-slate font-medium text-sm leading-snug" data-id="element-47" data-mp="2x5wbhi1p3gli">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}